import {EntityData, field} from "@fedeltapointofsale/data-client";

export class CreditOrderData extends EntityData<CreditOrderData> {
    @field creditOrderId: number;
}
